<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Client Photo</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="photo.name">
    <ng-container>
      <img
        [defaultImage]="THUMBNAIL_PHOTO_ROOT + '/' + photo.name"
        [lazyLoad]="BOOKING_PHOTO_FULL_RES_ROOT + '/' + photo.name"
        [errorImage]="BOOKING_PHOTO_ROOT + '/' + photo.name"
      />
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!photo.name">
    <img src="./assets/images/monster.png" />
  </ng-container>
</ion-content>